import { namespace } from 'vuex-class';

export const globalModule = namespace('global');
export const crossStorageModule = namespace('crossStorage');
